export function unFormatRut(rut) {
  let result = rut;
  result = result.replace(/-/g, "");
  result = result.replace(/\./g, "");
  return result;
}
export function formatRut(rut) {
  if (rut.length > 1) {
    let pos = 0;
    let sInvertido = '';
    let sRut = '';
    for (let i = rut.length - 1; i >= 0; i--) {
      sInvertido += rut.charAt(i);
      if (i === rut.length - 1) sInvertido += "-";
      else if (pos === 3) {
        sInvertido += ".";
        pos = 0;
      }
      pos++;
    }
    for (let j = sInvertido.length - 1; j >= 0; j--) {
      if (sInvertido.charAt(sInvertido.length - 1) !== ".")
        sRut += sInvertido.charAt(j);
      else if (j !== sInvertido.length - 1) sRut += sInvertido.charAt(j);
    }
    return sRut.toUpperCase();
  } else {
    return rut;
  }
}

export function validateRut(rutIn) {
  if (!rutIn || rutIn.length < 2) return false;

  // Elimina puntos, guiones y espacios
  const clean = rutIn.replace(/[.\-\s]/g, '');
  if (clean.length < 2) return false;

  const cuerpo = clean.slice(0, -1);
  const dv = clean.slice(-1).toLowerCase();

  if (!cuerpo || !dv) return false;

  const dvr = calcularDv(cuerpo);
  return dvr === dv;
}

export function quitarDv(rut) {
  let tempRut;
  let tempDv;
  let result = rut;
  if (rut && rut.length > 1) {
    tempRut = rut.substring(0, rut.length - 1);
    tempDv = calcularDv(tempRut)
    if (tempRut + tempDv === rut) {
      result = tempRut;
    }
  }
  return result;
}

export function calcularDv(rut) {
  let dvr = '0';
  let suma = 0;
  let mul = 2;
  for (let i = rut.length - 1; i >= 0; i--) {
    suma = suma + rut.charAt(i) * mul;
    if (mul === 7) mul = 2;
    else mul++;
  }
  const res = suma % 11;
  if (res === 1) dvr = "k";
  else if (res === 0) dvr = "0";
  else {
    const dvi = 11 - res;
    dvr = dvi + "";
  }
  return dvr;
}
